import React from "react";
import PropTypes from 'prop-types';
import classNames from "classnames";
import { Link } from "react-router-dom";

export default class PlaylistItem extends React.Component
{
    static propTypes = {
        projectId: PropTypes.string.isRequired,
        story: PropTypes.object.isRequired,
        active: PropTypes.bool
    }

    static defaultProps = {
        active: false
    };

    render()
    {
        const classes = {
            link: classNames("p-4", {
                'bg-gray-200': this.props.active,
                'hover:bg-gray-100': ! this.props.active
            })
        };

        return <Link to={`/projects/${this.props.projectId}/${this.props.story.id}`} className={classes.link}>
            <strong className="block mr-2">{this.props.story.name}</strong>
            <p>{this.props.story.description}</p>
        </Link>
    }
}
